import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';
import {
  AmountRange,
  AmountRangeKeys,
  NomineeCustomerInvestment,
} from './NomineeCustomerInvestments.types';
import { HeadCell } from '@components/Table/EnhancedTableHead';

const translationBase = 'portfolio.transactions';
const translationBaseAmountRange = `${translationBase}.amountRanges`;

export const headerCells: readonly HeadCell<NomineeCustomerInvestment>[] = [
  {
    id: 'id',
    numeric: false,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: 'crm.id',
    }),
  },
  {
    id: 'productName',
    numeric: false,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: `${translationBase}.product`,
    }),
  },
  {
    id: 'transactionId',
    numeric: false,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: 'crm.investments.transactionId',
    }),
  },
  {
    id: 'investmentDate',
    numeric: false,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: `${translationBase}.investmentDate`,
    }),
  },
  {
    id: 'amount',
    numeric: true,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: `${translationBase}.amount`,
    }),
  },
  {
    id: 'shares',
    numeric: true,
    disablePadding: false,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: `crm.investments.shares`,
    }),
  },
];

export const amountFilterRanges: { [key in AmountRangeKeys]: AmountRange } = {
  '10kTo50k': {
    from: 10000,
    to: 50000,
  },
  '50kTo100k': {
    from: 50000,
    to: 100000,
  },
  '100kTo250k': {
    from: 100000,
    to: 250000,
  },
  '250kToInfinity': {
    from: 250000,
  },
};

export const amountRangeMenuItems: { name: string; value: AmountRangeKeys }[] =
  [
    {
      name: GlobalIntlSingleton.intl.formatMessage({
        id: `${translationBaseAmountRange}.10kTo50k`,
      }),
      value: '10kTo50k',
    },
    {
      name: GlobalIntlSingleton.intl.formatMessage({
        id: `${translationBaseAmountRange}.50kTo100k`,
      }),
      value: '50kTo100k',
    },
    {
      name: GlobalIntlSingleton.intl.formatMessage({
        id: `${translationBaseAmountRange}.100kTo250k`,
      }),
      value: '100kTo250k',
    },
    {
      name: GlobalIntlSingleton.intl.formatMessage({
        id: `${translationBaseAmountRange}.250kToInfinity`,
      }),
      value: '250kToInfinity',
    },
  ];
